module.exports = __webpack_public_path__ + "img/client-vibestown.99b08b7b.png";